// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '../utils/helpers';

export interface MenuItemConfig {
  key: string;
  label: string;
  url: string;
}

export const getMenuResponsive = (selector: string): string => {
  const template = getTemplateIframeDocument();
  const element = template?.querySelector(selector);
  return element?.classList.contains('spm_responsive_menu') ? 'yes' : 'no';
};

export const getMenuItems = (selector: string): MenuItemConfig[] => {
  const template = getTemplateIframeDocument();
  const menuItems: Array<HTMLElement> = Array.from(template?.querySelectorAll(`${selector} .spm_menu_item`) || []);

  return menuItems.map((item, index) => {
    // Support both new structure (td > table > tbody > tr > th > a) and old structure (td > a)
    const link = item.querySelector('table > tbody > tr > th > a') as HTMLAnchorElement
      || item.querySelector('a') as HTMLAnchorElement;
    const label = link?.textContent || '';
    const url = link?.getAttribute('href') || '';

    return {
      key: `spm_menu_item_${index}_${Date.now()}`,
      label,
      url,
    };
  });
};
